// src/data/site.js
// Dados centralizados do site. Tudo que se repete (WhatsApp, Instagram,
// endereço, área de atendimento) vem daqui — nada hardcoded nos componentes.

export const SITE = {
  nome: "D•Rec Produções",
  dominio: "https://drecproducoes.com.br",
  whatsappNumero: "5581997882461",
  whatsappExibicao: "(81) 99788-2461",
  // Redes sociais: opcionais. Com null, os componentes não renderizam o link.
  // Reativar quando houver postagens.
  instagramHandle: null, // ex.: "@drec.producoes"
  instagramUrl: null, // ex.: "https://instagram.com/drec.producoes"
  youtubeUrl: null, // ex.: "https://youtube.com/drecproducoes"
  email: "contato@drecproducoes.com.br",
  endereco: "Av. Herculano Bandeira, 383 — Pina, Recife/PE",
  caixaPostal: "Caixa Postal 354",
  cnpj: "55.341.915/0001-52",
  areaAtendimento: "Região Metropolitana do Recife",
  prazoEntrega: "48h",
};

// Gera link do WhatsApp com mensagem pré-preenchida
export function whatsappLink(mensagem = "Olá! Vim pelo site da D-Rec e quero um orçamento para vídeo e fotos de imóvel.") {
  return `https://wa.me/${SITE.whatsappNumero}?text=${encodeURIComponent(mensagem)}`;
}
